import React from "react";
import {
  Button,
  Col,
  Grid,
  Image,
  Jumbotron,
  Row,
  Well,
} from "react-bootstrap";
import exportPreviewImage from "../../assets/export-preview.png";
import { Link } from "react-router-dom";
import { makeAuthRequest } from "../../http";

export const PaymentsPreview = ({ authenticated }) => {
  const onSubmit = async () => {
    const response = await makeAuthRequest().post(
      "/api/payments/create-checkout-session"
    );
    if (response.status === 200) {
      window.location.replace(response.data.checkout_url);
    }
  };

  return (
    <Grid>
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <h2>Full U.S. archive access now available!</h2>

          <p>
            Over the nearly seven years that I've maintained IBorrowDesk, it's
            gone from a project I used to learn to code to a site that regularly
            gets tens of thousands of unique visitors a day. During that time,
            I've gotten many requests to offer full access to the underlying
            database.
          </p>
          <p>
            I'm pleased to announce that full access to every stock in the U.S.
            database is now available! I've worked hard this year on several
            data migrations, taking into account symbol and CUSIP changes (many
            securities have changed CUSIPs upwards of ten times over seven
            years!) in order to present a much cleaner and more suitable for
            research database. If you're doing research or back-testing
            strategies I hope you will find this dataset useful.
          </p>

          <Well bsSize="large">
            <figure>
              <Image
                src={exportPreviewImage}
                alt="Screenshot from an exported file"
                responsive
                style={{ paddingBottom: "12px" }}
              />
              <figcaption>
                A snippet of AMC Entertainment Holdings exported CSV.
              </figcaption>
            </figure>
          </Well>

          <p>Subscribing to access this data set will provide the following:</p>
          <ul>
            <li>
              Daily fee and availability data beginning in July 2015, updated
              daily, and available on demand in the form of a ZIP archive of CSV
              formatted files.
            </li>
            <li>
              Daily high/low fee, availability, and rebate date beginning (in
              most cases) January 2021.
            </li>
          </ul>

          <Jumbotron>
            <p>
              I am offering one year of access to this dataset for a one-time
              payment of $500. If you are a long-time Patreon supporter, please
              contact me to receive discounted access!
            </p>
            <p>
              A sample of the archive containing the first 100 securities in the
              database is available <a href="/api/sample_export">here</a>.
              Checkout and payment are handled by Stripe.
            </p>
            <div align="center" style={{ margin: "12px" }}>
              <Button
                id="checkout-and-portal-button"
                bsSize="large"
                type="submit"
                disabled={!authenticated}
                onClick={onSubmit}
              >
                Checkout with Stripe
              </Button>
            </div>

            {!authenticated && (
              <p>
                Note: you must be an IBorrowDesk{" "}
                <Link to="/register">registered</Link> user in order to
                subscribe to this feature.
              </p>
            )}
            {authenticated && (
              <p>
                When checking out, ensure that the email address you use matches
                your IBorrowDesk account.
              </p>
            )}
          </Jumbotron>

          <h3>Terms and Conditions</h3>
          <p>
            Personal and professional use of the archive is permitted, however
            it may not be re-distributed in any form. Please contact me at
            cameron.mochrie@gmail.com if you have any questions about
            appropriate use.
          </p>
        </Col>
      </Row>
    </Grid>
  );
};
